import { InsightsSubMenu, ProtectionMenuNameOptions } from '@src/utils/enums';
import { IconType } from '../../shared/custom-icon/custom-icon';

export interface NavigationMenuOption {
    type: string,
    label: string,
    icon: IconType
}

export const protectionNavigationMenuOptions: NavigationMenuOption[] = [{
    type: ProtectionMenuNameOptions.GEO_FILTERING,
    label: 'Geo Filtering',
    icon: IconType.GEO_FILTERING
}, {
    type: ProtectionMenuNameOptions.WEB_FILTERING,
    label: 'Web Filtering',
    icon: IconType.WEB_FILTERING
}, {
    type: ProtectionMenuNameOptions.APPS,
    label: 'Apps',
    icon: IconType.APPS_LOGO //
}, {
    type: ProtectionMenuNameOptions.SERVICES,
    label: 'Services',
    icon: IconType.SERVICES_LOGO // 
}, {
    type: ProtectionMenuNameOptions.IP_CONTROL,
    label: 'IP Control',
    icon: IconType.IP_CONTROL
}, {
    type: ProtectionMenuNameOptions.PROTECTION_PLUS,
    label: 'Protection+',
    icon: IconType.PROTECTION_PLUS
}, {
    type: ProtectionMenuNameOptions.FIREWALL_RULES,
    label: 'Firewall Rules',
    icon: IconType.FIREWALL
}, {
    type: ProtectionMenuNameOptions.Library,
    label: 'Library',
    icon: IconType.INVENTORY
}];

export const insightsNavigationMenuOptions: NavigationMenuOption[] = [{
    type: InsightsSubMenu.REPORTS,
    label: 'Reports',
    icon: IconType.COPY
},{
    type: InsightsSubMenu.LOGS,
    label: 'Logs',
    icon: IconType.LOGS_SUB_MENU
},  {
    type: InsightsSubMenu.ACTIVITY,
    label: 'Activity',
    icon: IconType.ACTIVITY_SUB_MENU
}];

export interface SubMenuItem {
    type: string,
    label: string,
    icon: IconType
}

export const advancedProtectionSubMenu: SubMenuItem[] = [{
    type: ProtectionMenuNameOptions.FIREWALL_RULES,
    label: 'Firewall Rules',
    icon: IconType.FIREWALL
}, {
    type: ProtectionMenuNameOptions.Library,
    label: 'Library',
    icon: IconType.INVENTORY
}];

export const insightsSubMenu: SubMenuItem[] = [{
    type: InsightsSubMenu.LOGS,
    label: 'Logs',
    icon: IconType.REPORT_ACTIONS_BUTTON
}, {
    type: InsightsSubMenu.REPORTS,
    label: 'Reports',
    icon: IconType.REPORT_ACTIONS_BUTTON
}, {
    type: InsightsSubMenu.ACTIVITY,
    label: 'Activity',
    icon: IconType.REPORT_ACTIONS_BUTTON
}];